import { render, staticRenderFns } from "./ProductsSelect.template.vue?vue&type=template&id=04cbc1ce&scoped=true&"
var script = {}
import style0 from "./ProductsSelect.template.vue?vue&type=style&index=0&id=04cbc1ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cbc1ce",
  null
  
)

export default component.exports